<script>
  /**
   * @overview 七牛上传图片组件
   *
   * @author huojinzhao
   */

  import mapUtils, { $http, $token } from "@/utils";
  import PreviewAnimation from "./components/PreviewAnimation.vue";
  import PreviewAudio from "./components/PreviewAudio.vue";
  import PreviewImage from "./components/PreviewImage.vue";
  import PreviewVideo from "./components/PreviewVideo.vue";
  import PreviewPdf from "./components/PreviewPdf.vue";

  export default {
    name: "AppQiniu",

    components: {
      PreviewAnimation,
      PreviewAudio,
      PreviewImage,
      PreviewVideo,
      PreviewPdf,
    },

    props: {
      // 文件名称
      name: {
        type: String,
        default: "",
      },
      // 是否有路径地址
      isHas: {
        type: Boolean,
        default: false,
      },
      type: {
        type: String,
        required: true,
      },
      // 是否自己处理，如果自己处理直接return方法
      isSelf: {
        type: Boolean,
        default: false,
      },

      tokenUrl: {
        type: String,
        required: true,
      },


      tokenMode: {
        type: String,
        required: true,
      },

      value: {
        type: String,
        default: "",
      },

      previewUrl: {
        type: String,
        default: "",
      },

      action: {
        type: String,
        default: "https://upload.qiniup.com/",
      },

      bucket: {
        type: String,
        default: "https://oa-statics.caihonggou.com",
      },

      preview: {
        type: Boolean,
        default: false,
      },

      // 移动权限
      isMovePermissions: {
        type: Boolean,
        default: false,
      },
      // 是否可编辑，默认可以编辑
      isEdit: {
        type: Boolean,
        default: true,
      },
      // 是否打标签
      isLabel: {
        type: Boolean,
        default: true,
      },
    },

    data: () => ({
      // 是否上传中
      loading: false,

      targetInputID: null,

      fileTypes: {
        image: "png,jpg,jpeg",
        audio: "mp3,wav",
        video: "mp4,webm",
        rar: "zip",
        animation: "zip",
        doc: "doc, docx",
        pdf: "pdf",
        json: "json",
      },
      // 元素位置
      newOffsetTop: '',
    }),

    computed: {
      previewType() {
        let suffix = '';
        try {
          suffix = this.type
                  .slice(1)
                  .padStart(this.type.length, this.type[0].toUpperCase());
        } catch (e) {
          console.log(e);
        }

        if (suffix === 'Flash') {
          suffix = 'Image';
        }

        return `Preview${suffix}`;
      },

      fileName() {
        return this.value.split("/").pop();
      },

      fileDownload() {
        return `${this.value}`;
      },
    },

    mounted() {
      this.targetInputID = this.$refs.appFile.inputID;
    },

    methods: {
      ...mapUtils("form", ["errorAlert"]),

      beforeUpload(files) {
        if (this.isSelf) {
          this.$emit('onSelf', this.type);
          return false;
        }
        this.loading = true;

        const param = this.filterTokenApiParam(files[0]);

        return $http.get(`${this.tokenUrl}/${param}`)
                .then(({ token, key }) => {
                  this.qiniuUpload(token, key, files[0]);
                });
      },

      qiniuUpload(token, qkey, file) {
        const data = new FormData();

        data.append("token", token);
        data.append("key", qkey);
        data.append("file", file);

        return $http.post(this.action, data)
                .then(({ key }) => {
                  const url = `${this.bucket}/${key}`;

                  this.$emit("input", url);
                  this.$emit("success", { url });
                })
                .catch(this.$form_errorAlert)
                .finally(() => {
                  this.loading = false;
                });
      },

      filterTokenApiParam(file) {
        const methodMap = {
          type: name => name.split(".").pop(),
          name: name => name,
        };

        return methodMap[this.tokenMode](file.name);
      },

      resourceClear() {
        this.$emit("input", "");
        this.$emit("delete", { url: this.value });
      },

      resourcePreview() {
        this.$refs.content.preview();
      },

      resourceMove() {
        this.$emit('move');
      },

      resourceLabel() {
        const div = document.querySelector('html');
        let scrollTop = 0;
        console.log('html==>', div, div.scrollTop);
        if (div) {
          scrollTop = div.scrollTop;
        }
        const width = this.newOffsetTop + 225;
        this.$emit('label', width - scrollTop);
      },

      onSelf() {
        this.isSelf && this.$emit('onSelf', 'add');
      },

      onSelfEdit() {
        this.isSelf && this.$emit('onSelfEdit', 'edit');
      },
      /**
       * 获取 blob
       * @param  {String} url 目标文件地址
       * @return {cb}
       */
      getBlob(url, cb) {
        const xhr = new XMLHttpRequest();
        xhr.open('GET', url, true);
        xhr.responseType = 'blob';
        xhr.onload = function () {
          if (xhr.status === 200) {
            cb(xhr.response);
          }
        };
        xhr.send();
      },
      saveAs(blob, filename) {
        if (window.navigator.msSaveOrOpenBlob) {
          navigator.msSaveBlob(blob, filename);
        } else {
          const link = document.createElement('a');
          const body = document.querySelector('body');

          link.href = window.URL.createObjectURL(blob);
          link.download = filename;

          // fix Firefox
          link.style.display = 'none';
          body.appendChild(link);

          link.click();
          body.removeChild(link);

          window.URL.revokeObjectURL(link.href);
        }
      },

      /**
       * 下载
       * @param  {String} url 目标文件地址
       * @param  {String} filename 想要保存的文件名称
       */
      download() {
        let url = this.value;
        if (url.indexOf('?') > -1) {
          url += `&v=${Math.random()}`;
        } else {
          url += `?v=${Math.random()}`;
        }
        const filename = this.name;
        const self = this;
        self.getBlob(url, (blob) => {
          self.saveAs(blob, filename);
          });
      },
    },
  };
</script>

<template>
  <AppFile
    v-loading="loading"
    ref="appFile"
    v-bind="$attrs"
    :types="fileTypes[type]"
    :is-self="isSelf"
    :url="value"
    :is-add="!preview"
    :class="{'is-has':isHas}"
    :offset-top.sync="newOffsetTop"
    class="app-qiniu"
    @click.native.stop="onSelf"
    @success="beforeUpload"
    @error="$form_errorAlert"
    @create="$emit('create')"
  >
    <AppCard
      v-if="value && preview"
      slot="placeholder"
      class="layout-mask-master app-qiniu__preview"
      width="100%"
      height="100%"
      radius
    >
      <component
        ref="content"
        :is="previewType"
        :src="previewUrl || value"
        class="app-qiniu__content"
      />

      <slot name="preview-footer" />

      <template slot="mask" >
        <AppIcon
          v-if="isEdit"
          :for="targetInputID"
          element="label"
          type="edit"
          @click.stop="onSelfEdit"
        />
        <AppIcon
          type="preview"
          @click.prevent.stop="resourcePreview"
        />
        <AppIcon
          type="delete"
          @click.prevent.stop="resourceClear"
        />
        <AppIcon
          v-if="isMovePermissions"
          type="move"
          @click.prevent.stop="resourceMove"
        />
        <AppIcon
          type="download"
          @click.prevent.stop="download"
        />
        <AppIcon
          v-if="isLabel"
          type="label"
          @click.prevent.stop="resourceLabel"
        />
        <!--        <AppIcon-->
        <!--          :href="fileDownload"-->
        <!--          element="a"-->
        <!--          type="download"-->
        <!--        />-->
      </template>
    </AppCard>

    <slot
      v-else
      slot="placeholder"
      name="placeholder"
    />
  </AppFile>
</template>

<style lang="postcss">
  .is-has .layout-placeholder{
    display: none;
  }
  .app-qiniu {
    position: relative;
  }

  .app-qiniu:hover {
    border-color: var(--color-primary);
  }

  .app-qiniu__preview {
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    border: 2px dashed var(--bd-color-default);;
  }

  .app-qiniu__preview:hover {
    border-width: 2px;
  }

  .app-qiniu__content {
    flex-grow: 1;
    display: block;
    height: 160px;
  }

  .app-qiniu .layout-mask-attendant > .iconfont {
    margin: 0px 10px;
  }
</style>
